<template>
  <div>
    <v-row>
      <v-col cols="12">
        <PageTitle icon="mdi-accounts" text="کاربران" />
      </v-col>
      <v-col cols="12" class="pt-5">
        <v-data-table
          :headers="headers"
          :items="users"
          :loading="is_loading"
          :server-items-length="itemsLength"
          :footer-props="{
            'items-per-page-options': [10, 15, 20],
            'items-per-page-text': 'آیتم در صفحه:',
          }"
          @update:page="initUsers({ page: $event })"
          @update:items-per-page="initUsers({ limit: $event })"
          item-key="name"
          class="elevation-1"
        >
          <template v-slot:[`footer.page-text`]="items">
            {{ items.pageStart }} - {{ items.pageStop }} از
            {{ items.itemsLength }}
          </template>
          <template v-slot:top>
            <v-row>
              <v-col cols="4">
                <v-text-field
                  v-model="search"
                  label="جستجو بر اساس شماره تلفن"
                  class="mx-4"
                  append-icon="mdi-magnify"
                  @click:append="initUsers"
                ></v-text-field>
              </v-col>
            </v-row>
          </template>
          <template v-slot:item.createMoment="{ item }">
            {{ $_date(item.createMoment) }}
          </template>
          <template v-slot:item.state="{ item }">
            {{ $_t(`attribute.${item.state}`) }}
          </template>
          <template v-slot:item.isMobileVerify="{ item }">
            <v-icon color="success" v-if="item.isMobileVerify"
              >mdi-check-bold</v-icon
            >
            <v-icon v-else color="red">mdi-close-thick</v-icon>
          </template>
        </v-data-table>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import PageTitle from "@/packages/dashboard/components/PageTitle";

export default {
  name: "Users",
  components: { PageTitle },
  computed: {
    ...mapGetters({
      is_loading: "loading/is_loading",
      users: "admin/get_users",
      itemsLength: "pagination/get_items_length",
    }),
  },
  data: () => ({
    headers: [
      {
        text: "تاریخ ثبت",
        align: "start",
        sortable: true,
        value: "createMoment",
      },
      {
        text: "شماره تلفن همراه",
        align: "start",
        sortable: false,
        value: "mobileNumber",
      },
      {
        text: "تایید شده",
        align: "start",
        sortable: false,
        value: "isMobileVerify",
      },
      {
        text: "وضعیت",
        align: "start",
        sortable: true,
        value: "state",
      },
    ],
    search: "",
  }),
  methods: {
    async initUsers({ page = 1, limit = 10 }) {
      let schema = {
        page: {
          index: page,
          size: limit,
        },
        where: [
          [
            {
              column: "mobileNumber",
              comparison: "Contains",
              operand: this.search,
            },
          ],
        ],
      };
      await this.$actions.getUsers(schema);
    },
  },
  mounted() {
    this.initUsers({});
  },
};
</script>

<style scoped></style>
